<template>
  <div class="w-full">
      <div class="text-center text-3xl py-6">{{ _("This order has been cancelled. Please stand by.")}}</div>
  </div>
</template>

<script>
import PhoneFormatter from "../Shared/PhoneFormatter";
import {lang} from "../lang";
import IconClockOutline from "../../icons/outline/IconClockOutline";
export default {
  name: "OrderCanceled",
    components: {IconClockOutline, PhoneFormatter},
    props: [
        'app_locale'
    ],
    data() {
        return {
            grabbing: false,
        }
    },
    
    methods: {
      
      
        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
}
</script>

<style scoped>

</style>
